import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    padding: [10, 0, 10, 0],
    borderBottom: `1px solid ${theme.palette.colors.border}`,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  loanOfficerBadge: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    padding: [0, theme.spacing(3)],
  },
  loanOfficerInfo: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  avatar: {
    width: 52,
    height: 52,
    marginRight: theme.spacing(2),
  },
  name: {
    lineHeight: '20px',
    width: 140,
  },
  onineStatus: {
    color: theme.palette.colors.white,
    width: 40,
    height: 16,
    backgroundColor: theme.palette.colors.lightGreen,
    borderRadius: 2,
    letterSpacing: '0.01em',
    textTransform: 'uppercase',
    marginLeft: 4,
    fontSize: 10,
    lineHeight: '16px',
    textAlign: 'center',
    padding: [0, 2],
  },
  bidBadge: {
    padding: [0, theme.spacing(3)],
    marginTop: 10,
    borderTop: `1px solid ${theme.palette.colors.border}`,
    display: 'flex',
    height: 55,
    alignItems: 'center',
    justifyContent: 'center',
  },
  noBidBadge: {
    padding: [0, theme.spacing(3)],
    marginTop: 10,
    borderTop: `1px solid ${theme.palette.colors.border}`,
    display: 'flex',
    flexDirection: 'column',
    height: 55,
    alignItems: 'center',
    justifyContent: 'center',
  },
  noBidBadge2: {
    display: 'flex',
    alignItems: 'center',
  },
  bidInfoText: {
    marginTop: 5,
    color: theme.palette.colors.darkBlueGray,
  },
  bottomBarLeft: {
    width: 110,
  },
  bottomBarCenter: {
    width: 80,
  },
  bottomBarRight: {
    width: 110,
  },
  loButton: {
    height: 32,
    width: '100%',
    '&:hover': {
      backgroundColor: theme.palette.colors.lightTeal,
      boxShadow: 'none',
    },
    textDecoration: 'none',
  },
  loButton2: {
    backgroundColor: theme.palette.colors.lightTeal,
    color: theme.palette.colors.teal,
    height: 32,
    width: '100%',
    '&:hover': {
      boxShadow: 'none',
      color: theme.palette.colors.white,
    },
    textDecoration: 'none',
  },
  loLinksBox: {
    padding: [0, theme.spacing(3)],
    '& a:nth-child(2)': {
      marginLeft: theme.spacing(2),
    },
    marginTop: 5,
    display: 'flex',
    justifyContent: 'space-between',
  },
  backButton: {
    marginRight: theme.spacing(1),
  },
  icon: { fill: theme.palette.colors.white },
}));



// WEBPACK FOOTER //
// ./src/components/BuyerMessages/components/MobileMessages/components/ChatPage/components/LoanOfficerCard/useStyles.js